import { EquipmentEnum, GamePlayData, UpgradeEnum } from '@/types'
import { UPGRADES } from '@/constants/upgrades'
import { JOBS } from '@/constants/jobs'
import { applyMultipliers, removeMultipliers } from './multipliers'

interface FeeItem {
  name: string
  hourlyFee: number
}

export function calculateEquipmentFees(gameData: GamePlayData): {
  totalFees: number
  feeBreakdown: FeeItem[]
} {
  let totalFees = 0
  const feeBreakdown: FeeItem[] = []
  const equipmentTypes: ('housing' | 'other')[] = ['housing', 'other']

  equipmentTypes.forEach((type) => {
    const equipment = gameData.equipment[type]
    if (equipment) {
      const items = Array.isArray(equipment) ? equipment : [equipment]
      items.forEach((itemKey) => {
        const item = UPGRADES[itemKey as UpgradeEnum]
        if (item?.hourlyFee) {
          totalFees += item.hourlyFee
          feeBreakdown.push({
            name: item.name,
            hourlyFee: item.hourlyFee
          })
        }
      })
    }
  })
  return { totalFees, feeBreakdown }
}

export function getIncomeBreakdown(gameData: GamePlayData): {
  jobIncome: number
  hourlyFees: number
  netIncome: number
  feeBreakdown: FeeItem[]
} {
  const { totalFees, feeBreakdown } = calculateEquipmentFees(gameData)
  const jobIncome =
    gameData.currentJob && gameData.currentActivity === 'work' ? JOBS[gameData.currentJob]?.income ?? 0 : 0
  const netIncome = jobIncome - totalFees

  return {
    jobIncome,
    hourlyFees: totalFees,
    netIncome,
    feeBreakdown
  }
}

export function getEquipmentChangeData(
  gameData: GamePlayData,
  type: EquipmentEnum,
  newEquipment: UpgradeEnum | UpgradeEnum[] | undefined
): GamePlayData {
  // Remove existing equipment multipliers
  let newData = removeMultipliers(gameData, 'upgrade', `${type}`)

  // Apply new equipment multipliers
  if (newEquipment) {
    const equipmentItems = Array.isArray(newEquipment) ? newEquipment : [newEquipment]
    equipmentItems.forEach((itemKey) => {
      const item = UPGRADES[itemKey as UpgradeEnum]
      if (item?.effects) {
        newData = applyMultipliers(newData, item.effects, `${type}`, 'upgrade')
      }
    })
  }

  return {
    ...newData,
    equipment: {
      ...newData.equipment,
      [type]: newEquipment
    }
  }
}
